export const ETATS_EVENEMENT = [
  { id: 0, description: 'Non disponible en ligne' },
  { id: 1, description: 'Disponible en ligne' },
  { id: 2, description: 'Complet' },
  { id: 3, description: 'Possibilité complémentaire' },
  { id: 4, description: 'En construction' },
];
